module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Illustrations"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Abbreviations"
    }
  }, [_vm._v("List of Abbreviations and Acronyms")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("1")]), _vm._v(" A Panoramic: Left to Right")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1_1"
    }
  }, [_vm._v("Action!")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1_2"
    }
  }, [_vm._v("Woes of capitalism")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1_3"
    }
  }, [_vm._v("Popular culture and populist rhetoric")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1_4"
    }
  }, [_vm._v("For sale")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1_5"
    }
  }, [_vm._v("Good‐bye Goskino. Hello “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("goszakaz")]), _vm._v("”")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1_6"
    }
  }, [_vm._v("On the “right” side")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("2")]), _vm._v(" History in the Making and on Screen")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forward to the past")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History lessons and tales")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch2_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The day the White House turned black")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch2_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The search for Russia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("3")]), _vm._v(" New Babylon")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A hit")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moscowville")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOSKVA")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Urban wolves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The people strike back")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outside and inside")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life goes on")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A flashback")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("4")]), _vm._v(" Faraway in Space and Time")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lukomore")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paradise lost")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fabricated worlds")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nightmarish landscapes")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soviet dystopias")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("War theaters")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("5")]), _vm._v(" Laughter through Tears")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Whom are you laughing at?”")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fluttering butterflies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The new poor")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the rearview mirror")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The prospectors")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patriotic comedies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the beginning was the kiosk")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not by bread alone")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invitation to the circus")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Filmography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0